export default __webpack_public_path__ + "static/media/chungungo_brand.8b2458aa.svg";